export default {
      id: "icon--food-usage",
      viewBox: "0 0 32 27",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--food-usage",
      toString: function () {
        return this.url;
      }
    }